'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentGooglepayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M40.4322 34.9714V28.4303V28.429H43.9665C45.4236 28.4299 46.6482 27.9715 47.6403 27.0538C48.6429 26.1828 49.2035 24.9306 49.175 23.6254C49.1948 22.3273 48.6353 21.0844 47.6403 20.2162C46.6569 19.2935 45.3343 18.7901 43.9665 18.8178H38.293V34.9714H40.4322ZM40.4322 26.4454V20.8066V20.8053H44.0196C44.8192 20.7835 45.59 21.0956 46.1362 21.6624C46.6859 22.1807 46.996 22.8927 46.996 23.6363C46.996 24.3799 46.6859 25.0919 46.1362 25.6102C45.5833 26.1651 44.8149 26.4683 44.0196 26.4454H40.4322Z",
          fill: "#5F6368"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M57.8485 24.7879C56.9335 23.9682 55.6854 23.5583 54.1043 23.5583C52.0732 23.5583 50.5394 24.2801 49.503 25.7236L51.3871 26.8746C52.0833 25.8968 53.0289 25.4078 54.2239 25.4078C54.9857 25.3992 55.723 25.6693 56.2887 26.1644C56.8527 26.6168 57.1771 27.2912 57.1722 28.0011V28.4754C56.3502 28.0243 55.3041 27.7987 54.0339 27.7987C52.5457 27.8005 51.3561 28.139 50.465 28.8144C49.5739 29.4898 49.1283 30.3993 49.1283 31.543C49.1089 32.5843 49.5746 33.5787 50.3959 34.2496C51.241 34.9714 52.2911 35.3323 53.5462 35.3323C55.0167 35.3323 56.1948 34.7007 57.0806 33.4376H57.1736V34.9714H59.2198V28.1596C59.2206 26.7315 58.7636 25.6076 57.8485 24.7879ZM52.0462 32.9414C51.5981 32.6281 51.3338 32.1239 51.3367 31.5881C51.3367 30.9862 51.6277 30.4848 52.2137 30.0723C52.7939 29.6659 53.5184 29.4627 54.3874 29.4627C55.5806 29.4627 56.5107 29.7205 57.1777 30.236C57.1777 31.1073 56.8233 31.8665 56.1147 32.5135C55.4764 33.1327 54.6111 33.4813 53.7084 33.4827C53.1066 33.4937 52.5194 33.3024 52.0462 32.9414Z",
          fill: "#5F6368"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.9656 23.9192L63.8225 39.8434H61.6142L64.265 34.2715L59.568 23.9192H61.8932L65.2881 31.8587H65.3346L68.6364 23.9192H70.9656Z",
          fill: "#5F6368"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M31.7877 27.0203C31.7885 26.3879 31.7333 25.7566 31.6229 25.1334H22.6011V28.7075H27.7684C27.5547 29.8609 26.8645 30.8797 25.8577 31.5275V33.8475H28.9416C30.7473 32.2326 31.7877 29.8443 31.7877 27.0203Z",
          fill: "#4285F4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.601 36.0889C25.1827 36.0889 27.3564 35.2666 28.9416 33.8488L25.8577 31.5288C24.9993 32.0933 23.8939 32.4155 22.601 32.4155C20.1058 32.4155 17.9878 30.7838 17.2305 28.585H14.0536V30.9759C15.6774 34.1104 18.9846 36.0887 22.601 36.0889Z",
          fill: "#34A853"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.2306 28.585C16.8302 27.4328 16.8302 26.185 17.2306 25.0328V22.6419H14.0537C12.6954 25.2637 12.6954 28.3541 14.0537 30.9759L17.2306 28.585Z",
          fill: "#FBBC04"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.601 21.2022C23.9653 21.1806 25.2836 21.6806 26.2709 22.5942L29.0014 19.9455C27.27 18.368 24.9762 17.502 22.601 17.5289C18.9846 17.529 15.6774 19.5074 14.0536 22.6419L17.2305 25.0328C17.9878 22.8339 20.1058 21.2022 22.601 21.2022Z",
          fill: "#EA4335"
        }
      )
    ]
  }
);
const VpPaymentGooglepayAsset = forwardRef(PaymentGooglepayAsset);

export { VpPaymentGooglepayAsset as default };
